/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Manager가 스프린트에서 일을 하기 위해 Test를 치뤄야 하는데 그 Test의 진행 및 합격 여부 상태
 */
export type ManagerTestStatusType = 'Pending' | 'Completed' | 'Passed' | 'Failed';

export const ManagerTestStatusType = {
    Pending: 'Pending' as ManagerTestStatusType,
    Completed: 'Completed' as ManagerTestStatusType,
    Passed: 'Passed' as ManagerTestStatusType,
    Failed: 'Failed' as ManagerTestStatusType
};

